// extracted by mini-css-extract-plugin
module.exports =  {"icon":"hIgPs1Z","fiverr-learn-logo":"mZE43nv","fiverrLearnLogo":"mZE43nv","title":"Wwbq8E3"};